import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetCollectionSubtitleV2Request } from './get-collection-subtitle-v2-request';
import type { IGetCollectionSubtitleV2Response } from './get-collection-subtitle-v2-response';
import { getCollectionSubtitleV2ResponseSchema } from './get-collection-subtitle-v2-response';

export async function getCollectionSubtitleV2Api({
  collectionId,
}: IGetCollectionSubtitleV2Request): Promise<IValidatedResponse<IGetCollectionSubtitleV2Response>> {
  return getRequest<IGetCollectionSubtitleV2Response>({
    path: `/sys/collections/${collectionId}/subtitles/v2`,
    schema: getCollectionSubtitleV2ResponseSchema,
  });
}
